import {
  ApiClient,
  ApiClientContext,
  ApiClientOptions,
  defaultAxiosConfig,
} from '@qualifio/api-client';
import { AxiosInstance } from 'axios';
import { Asset } from './types';

export class AssetApiClient extends ApiClient {
  static serviceName = 'assets-api';

  constructor(http?: AxiosInstance, context?: ApiClientContext, options?: ApiClientOptions) {
    super('/api/assets', http, context, options);
  }

  async uploadFile(programId: string, type: string, file: File): Promise<Asset> {
    const formData = new FormData();
    formData.set('file', file);

    const { data } = await this.http.post(`/programs/${programId}/upload/${type}`, formData, {
      ...defaultAxiosConfig(),
      headers: {
        'content-type': 'multipart/form-data',
      },
    });

    return data;
  }
}
